module.exports = __webpack_public_path__ + "11_hige_black.f86dea94.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/11_hige_black.png
// module id = ktPM
// module chunks = 0